const TableBody = ({ children }) => {
  return <tbody className="relative w-full divide-y divide-gray-200 bg-white overflow-y-auto">{children}</tbody>;
};

export default TableBody;
